// Reusable component for displaying sample products on solution pages
import { useState, useEffect } from 'react';
import { useGlobal } from '@/context/GlobalContext';
import axios from 'axios';

export const SampleProducts = ({ endpoint, title, subtitle, limit = 4, renderCard }) => {
  const { API } = useGlobal();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchItems = async () => {
      try {
        const response = await axios.get(`${API}/${endpoint}`);
        setItems(response.data.slice(0, limit));
      } catch (error) {
        console.log('No products to display');
      } finally {
        setLoading(false);
      }
    };
    fetchItems();
  }, [API, endpoint, limit]);

  if (loading) return null;
  if (items.length === 0) return null;

  return (
    <section className="py-16 px-4 sm:px-6 lg:px-8 bg-[#141824]">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-white mb-4 font-['Montserrat']">{title}</h2>
          <p className="text-slate-400 max-w-2xl mx-auto">{subtitle}</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {items.map((item, idx) => renderCard(item, idx))}
        </div>
        <p className="text-center text-slate-500 text-sm mt-8">
          * These are representative samples. Contact us for current availability and custom configurations.
        </p>
      </div>
    </section>
  );
};

// Default product card style
export const ProductCard = ({ image, title, description, tags = [], Icon }) => (
  <div className="rounded-2xl bg-[#232a3b] border border-[#3d4758] overflow-hidden hover:border-[#5b3589] transition-colors">
    <div className="aspect-video bg-[#1a1f2e] relative">
      {image ? (
        <img src={image} alt={title} className="w-full h-full object-cover opacity-90" />
      ) : Icon ? (
        <div className="w-full h-full flex items-center justify-center">
          <Icon className="w-12 h-12 text-[#3d4758]" />
        </div>
      ) : null}
    </div>
    <div className="p-4">
      <h3 className="text-lg font-semibold text-white mb-2 font-['Montserrat']">{title}</h3>
      <p className="text-slate-400 text-sm mb-3 line-clamp-2">{description}</p>
      {tags.length > 0 && (
        <div className="flex flex-wrap gap-2">
          {tags.map((tag, i) => (
            <span key={i} className="text-xs px-2 py-1 rounded bg-[#5b3589]/20 text-[#a78bfa]">{tag}</span>
          ))}
        </div>
      )}
    </div>
  </div>
);

export default SampleProducts;
